import React, {useRef, useContext} from 'react';
import * as R from 'ramda';

import useAPI from '@/hooks/useAPI';
import * as apis from '@/b2b/apis';

// import dompurify from 'dompurify';
import Frame from 'react-frame-component';
import {PopError} from '@/b2b/components/Pop';

import {getCurrentPolicy} from '@/b2b/pages/PolicyStatement/state';
import {PolicyStatementCtx} from '@/b2b/contexts';

const statementFetcher = (accountType, partyId, currency) => {
  if (accountType === 'CONSOLIDATE') {
    return apis.consolidateStatement(partyId, currency);
  }
  return apis.policyStatement(partyId);
};

const InnerHtml = () => {
  const [state] = useContext(PolicyStatementCtx);
  const {accountType} = getCurrentPolicy(state);
  const {result, error, loading} = useAPI(statementFetcher, {
    args: [accountType, state.partyId, state.currency],
  });
  const iframeRef = useRef(null);

  if (loading) {
    return 'Loading...';
  }

  if (error) {
    return <PopError error={String(error)} />;
  }
  // const cleanup = dompurify.sanitize(html); # FIXME: currently the statement css will cleanup as well
  const cleanup = result.data;

  const handleResize = () => {
    setTimeout(() => {
      const scrollHeight = R.path(
        ['current', 'node', 'contentDocument', 'body', 'scrollHeight'],
        iframeRef
      );
      if (scrollHeight > 200) {
        iframeRef.current.node.height = scrollHeight + 50;
      }
    }, 100);
  };

  const iframeStyle = {width: '100%', border: '0px'};

  return (
    <Frame
      onLoad={handleResize}
      ref={iframeRef}
      style={iframeStyle}
      initialContent={`<!DOCTYPE html><html><head></head><body><div id="mountHere">${cleanup}</div></body></html>`}
      mountTarget='#mountHere'
    />
  );
};

export default InnerHtml;
